import { Box, BoxProps } from "@chakra-ui/react";

function InquiriesIcon({
  color = "#0D0D0D",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.6706 21.3905C18.8536 21.1125 22.1856 17.7332 22.4598 13.4909C22.5134 12.6607 22.5134 11.8009 22.4598 10.9707C22.1856 6.72838 18.8536 3.34913 14.6706 3.07107C13.2435 2.97621 11.7536 2.97641 10.3294 3.07107C6.14639 3.34913 2.81441 6.72838 2.54024 10.9707C2.48659 11.8009 2.48659 12.6607 2.54024 13.4909C2.6401 15.036 3.32343 16.4666 4.12791 17.6746C4.59501 18.5203 4.28674 19.5758 3.80021 20.4978C3.44941 21.1626 3.27401 21.495 3.41484 21.7351C3.55568 21.9752 3.87026 21.9829 4.49943 21.9982C5.74367 22.0285 6.58268 21.6757 7.24868 21.1846C7.6264 20.9061 7.81527 20.7668 7.94544 20.7508C8.0756 20.7348 8.33177 20.8403 8.84401 21.0513C9.3044 21.2409 9.83896 21.3579 10.3294 21.3905C11.7536 21.4852 13.2435 21.4854 14.6706 21.3905Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M11 10.0385C11 9.18879 11.6716 8.5 12.5 8.5C13.3284 8.5 14 9.18879 14 10.0385C14 10.3447 13.9127 10.6301 13.7623 10.8698C13.3141 11.5844 12.5 12.2657 12.5 13.1154V13.5"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M12.5 15.5H12.509"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}

export { InquiriesIcon };
